import { Link } from 'omakase';

export const privacyEmailAnchor = () => {
  return <Link href="mailto:privacy@tockhq.com">privacy@tockhq.com</Link>;
};

export const arbOptOutEmailAnchor = () => {
  return <Link href="mailto:arbitration-opt-out@tockhq.com">arbitration-opt-out@tockhq.com</Link>;
};

export const cookiePolicyLink = (text?: string) => {
  const linkText = text?.trim() ? text : 'Cookie Policy';
  return <Link href="/cookie-policy">{linkText}</Link>;
};

export const termsLink = (text?: string, openInNewTab?: boolean) => {
  const linkText = text?.trim() ? text : 'Terms of Use';
  return createLink('/terms', linkText, !!openInNewTab);
};

export const conciergeTermsLink = (text?: string) => {
  const linkText = text?.trim() ? text : 'Concierge Terms';
  return <Link href="/concierge-terms">{linkText}</Link>;
};

export const privacyPolicyLink = (text?: string, openInNewTab?: boolean) => {
  const linkText = text?.trim() ? text : 'Privacy Policy';
  return createLink('/privacy', linkText, !!openInNewTab);
};

export const privacySpecificLink = (text?: string) => {
  const linkText = text?.trim() ? text : 'this page';
  return <Link href="/privacy-specific">{linkText}</Link>;
};

export const helpCenterLink = (text?: string, anchor?: string) => {
  const linkText = text?.trim() ? text : 'this Guest help center page';
  const href = anchor ? `/help${anchor}` : `/help`;
  return <Link href={href}>{linkText}</Link>;
};

export const merchantTermsLink = (text?: string) => {
  const linkText = text?.trim() ? text : 'Merchant Terms';
  return <Link href="/merchant-terms">{linkText}</Link>;
};

const createLink = (href: string, linkText: string, openInNewTab: boolean) => {
  const newTabAttributes = {
    ...(openInNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : {}),
  };
  return (
    <Link href={href} {...newTabAttributes}>
      {linkText}
    </Link>
  );
};
